// extracted by mini-css-extract-plugin
module.exports = {"svgContainer":"svg-markup-module--svg-container--1b_Xf"};